import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_MODELE_SCHEMA_LITERAL = {
    title: 'Schéma Modèles',
    description: 'Modèles',
    version: 0,
    keyCompression: false,
    primaryKey: 'CBMARQ_STR',
    type: 'object',
    properties: {
        CBMARQ_STR: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        MO_NO: { type: 'number' },
        MO_INTITULE: { type: ['string', 'null'] },
        MO_CALCUL: { type: ['string', 'null'] }
    },
    required: [ 'CBMARQ', 'MO_NO', 'MO_INTITULE', 'MO_CALCUL' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_MODELE_SCHEMA_LITERAL);
export type RxFModeleDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_MODELE_SCHEMA: RxJsonSchema<RxFModeleDocumentType> = F_MODELE_SCHEMA_LITERAL;
